import { Box } from "@mui/material";
import DashboardComponent from "../components/DashboardComponent";
import { CDashboardModuleTabComponent } from "../../DashboardApp/types";
import ErrorBoundary from "../ErrorBoundary";

interface ComponentDomPreviewProps {
	component: CDashboardModuleTabComponent;
}

const ComponentDomPreview: React.FC<ComponentDomPreviewProps> = ({ component }) => {
	return (
		<Box sx={{ display: "flex", flex: 1 }}>
			<ErrorBoundary>
				<DashboardComponent component={component} />
			</ErrorBoundary>
		</Box>
	);
};

export default ComponentDomPreview;
